/**
 * D8 (2.1.0) — invite code display + input rules, mirroring the backend:
 * new codes are 6 chars shown as a 3+3 split; legacy 8-char codes stay as-is;
 * user input tolerates separators, spaces and lowercase.
 */

export function formatInviteCode(code: string): string {
  return code.length === 6 ? `${code.slice(0, 3)}-${code.slice(3)}` : code;
}

export function normalizeInviteCode(raw: string): string {
  return raw.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
}
